import { useState, useEffect } from 'react';

import { useGetOrganizationsQuery } from '../../common/apis/AdminApi';
import { Organization } from '../../common/types/Organization';

const useFilteredOrganizations = (
  limit: number,
  sortParams: { sortField?: string; direction?: string },
  searchText?: string
) => {
  const [page, setPage] = useState<number>(1);
  const [filteredResults, setFilteredResults] = useState<Organization[]>([]);
  const { sortField, direction } = sortParams;

  const { data, isFetching: isLoading } = useGetOrganizationsQuery(
    {
      page: page,
      limit,
      search: searchText,
      sortField,
      direction,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  useEffect(() => {
    const { docs: results } = { ...data };
    if (results) {
      setFilteredResults(results);
    }
  }, [data]);

  return {
    filteredResults,
    isLoading,
    total: data?.total ?? 0,
    page,
    setPage,
  };
};

export default useFilteredOrganizations;
